import { Pagination } from "services/search";
import { DataWithPagination } from "services/api/types";
import {
  FleetWarehouse,
  FleetWarehouseEditFormValues,
  FleetWarehouseRow,
} from "./types";
import {
  transformFleetWarehouse,
  transformFleetWarehouseOnCreate,
  transformFleetWarehouseOnUpdate,
  transformFleetWarehouseRow,
} from "./transformations";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";
import { DropdownCacheKey, invalidateDropdownCache } from "services/hooks/useDropdownCache";

/*---------------------------------------------------------------------------------------
  SEARCH
-----------------------------------------------------------------------------------------*/
export const getFleetWarehousesAPI = async (
  pagination: Pagination,
  name?: string | null,
  address?: string | null,
  contactId?: string | null
): Promise<DataWithPagination<FleetWarehouseRow>> => {
  let path = `/v1/fleet/warehouses?name=`;

  if (name) path += `${encodeURIComponent(name)}`;
  if (address) path += `&address=${encodeURIComponent(address)}`;
  if (contactId) path += `&contactId=${contactId}`;

  return await paginatedApiCall(path, pagination, transformFleetWarehouseRow);
};

/*---------------------------------------------------------------------------------------
    INFO
  -----------------------------------------------------------------------------------------*/
export const getFleetWarehouseAPI = async (
  id: string
): Promise<FleetWarehouse> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/warehouses/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformFleetWarehouse(response.data);
};

/*---------------------------------------------------------------------------------------
    FLEET - WAREHOUSE - CREATE
-----------------------------------------------------------------------------------------*/

export const createFleetWarehouseAPI = async (
  formValues: FleetWarehouseEditFormValues
): Promise<FleetWarehouse> => {
  const response = await createApiCall(
    {
      path: "/v1/fleet/warehouses",
      method: "POST",
      body: transformFleetWarehouseOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Skladište je uspješno kreirano",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  invalidateDropdownCache(DropdownCacheKey.FleetWarehouses);
  return transformFleetWarehouse(response.data);
};

/*---------------------------------------------------------------------------------------
    FLEET - WAREHOUSE - UPDATE
-----------------------------------------------------------------------------------------*/

export const updateFleetWarehouseAPI = async (
  id: string,
  formValues: FleetWarehouseEditFormValues
): Promise<FleetWarehouse> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/warehouses/${id}`,
      method: "PUT",
      body: transformFleetWarehouseOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Skladište je uspješno ažurirano",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  invalidateDropdownCache(DropdownCacheKey.FleetWarehouses);
  return transformFleetWarehouse(response.data);
};

/*---------------------------------------------------------------------------------------
    FLEET - WAREHOUSE - DELETE
-----------------------------------------------------------------------------------------*/
export const deleteWarehouseAPI = async (
  id: string
): Promise<FleetWarehouse> => {
  const response = await createApiCall(
    {
      path: `/v1/fleet/warehouses/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Skladište je uspješno obrisano",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  invalidateDropdownCache(DropdownCacheKey.FleetWarehouses);
  return transformFleetWarehouse(response.data);
};
